import React, { useState, useMemo, useEffect } from 'react';
import classnames from 'classnames';
import { useResizeDetector } from 'react-resize-detector';
import { Content } from '@leverege/ui-elements';
import ResponsiveModel from "./ResponsiveModel.js";
import S from './ResponsiveView.css';
import { rdvm } from "../Util.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ResponsiveView(props) {
  const {
    className,
    areaClassName,
    headerClassName,
    footerClassName,
    settings,
    settingsData,
    onSettingsChange,
    useContentView = false,
    contentHeader,
    contentFooter,
    contentHorizontal = false,
    relative
  } = props;
  const [entry, setDataViewer] = useState();
  const {
    ref,
    width
  } = useResizeDetector({
    handleHeight: false
  });

  // Make sure we update the entry state when the settings change
  useEffect(() => {
    if (settings && width) {
      const dv = ResponsiveModel.getDataViewerForSize(settings, width);
      setDataViewer(dv);
    }
  }, [settings, width]);
  const renderer = useMemo(() => {
    const dataViewerModel = entry && entry[0];
    if (dataViewerModel == null) {
      return null;
    }
    const onChange = evt => {
      const nModel = ResponsiveModel.setDataViewerSettings(settings, evt.data, evt.value);
      const nEvt = {
        value: nModel,
        data: settingsData
      };
      onSettingsChange(nEvt);
    };
    return rdvm(dataViewerModel, props, {
      settings: entry?.[0],
      settingsData: entry[1],
      onSettingsChange: onChange
    });
  }, [entry?.[0], entry?.[1], props]);
  if (useContentView) {
    return /*#__PURE__*/_jsxs(Content, {
      className: classnames(S.content, className),
      domRef: ref,
      horizontal: contentHorizontal,
      relative: relative,
      children: [contentHeader && /*#__PURE__*/_jsx(Content.Header, {
        className: headerClassName,
        children: contentHeader(entry?.[0], entry?.[1])
      }), /*#__PURE__*/_jsx(Content.Area, {
        className: areaClassName,
        children: renderer
      }), contentFooter && /*#__PURE__*/_jsx(Content.Footer, {
        className: footerClassName,
        children: contentFooter(entry?.[0], entry?.[1])
      })]
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: S.content,
    ref: ref,
    children: renderer
  });
}
export default /*#__PURE__*/React.memo(ResponsiveView);